import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class PriceBookQueryCriteriaClass extends BaseCriteriaModel {
  //for header, bl_fi_mst_price_book_hdr table
  code?: Optional<string> = Optional.empty();
  namespace?: Optional<string> = Optional.empty();
  price_book_type?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
  
  //for extensions, bl_fi_mst_price_book_ext table
  hdr_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty(); 
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
}

export class PriceBookCriteriaModelQuery {
  query = '';

  constructor(PriceBooklCriteriaModel: PriceBookQueryCriteriaClass) {

    if (!PriceBooklCriteriaModel) {
      return;
    }

    this.query += PriceBooklCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.price_book_type.filter(x => x !== '').map(x => '&price_book_type=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += PriceBooklCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += PriceBooklCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + PriceBooklCriteriaModel.status;
    this.query += '&orderBy=' + PriceBooklCriteriaModel.orderBy;
    this.query += '&order=' + PriceBooklCriteriaModel.order;
    this.query += '&offset=' + PriceBooklCriteriaModel.offset + '&limit=' + PriceBooklCriteriaModel.limit;
  }
}

